<template>
<b-modal size="lg"
  :visible="shown" 
  centered 
  title="Utwórz styl" 
  ok-title="Zapisz"
  cancel-title="Anuluj"
  @hidden="hide" 
  @ok="createStyle">
  <b-alert variant="danger" v-show="showError">
    <strong>Formularz zawiera błędy</strong>
  </b-alert>
  <form-layer-style ref="styleControl" :geometry="geometry" :attributes="attributes" :layer-id="layerId" size="lg" icon-picker-type="dropdown" v-if="loaded"></form-layer-style>
</b-modal>
</template>

<script>
import FormLayerStyle from "./layer/FormLayerStyle";
import LayerStyleStore from "./layer/store/LayerStyleStore";
import { STYLES_SAVE } from "../store/actions.type";
import { mapGetters } from "vuex";

export default {
  name: "LayerStyleWindow",
  components: { FormLayerStyle },
  data: function() {
    return {
      layer: undefined,
      shown: false,
      showError: false,
      loaded: false
    };
  },
  computed: {
    ...mapGetters(["styles"]),
    geometry() {
      return this.layer ? (this.layer.type === "wfs" ? this.layer.basicGeometryType : this.layer.type) : null;
    },
    attributes() {
      return this.layer && this.layer.attributes ? this.layer.attributes.filter(x => !x.hasOwnProperty('read_only') || x.read_only !== true) : [];
    },
    layerId() {
      return this.layer ? this.layer.id : null;
    }
  },
  methods: {
    createStyle(e) {
      if (this.$refs.styleControl.validate()) {
        e.preventDefault();

        this.showError = true;
        return;
      }
      let store = new LayerStyleStore();
      let style = store.getStyle();
      style.id = null;
      style.id_warstwy = this.layerId;
      style.domyslny = false;

      this.$store.dispatch(STYLES_SAVE, style);
      this.loaded = false;
      this.hide();
    },
    setLayer(layer) {
      this.layer = layer;
      let store = new LayerStyleStore();
      store.clear();
      if (layer.styleId) {
        let style = this.styles.find(x => x.id === layer.styleId);

        if (style) {
          store.setStyle(style);
        }
      }
      this.loaded = true;
      this.shown = true;
    },
    hide() {
      this.shown = false;
    }
  }
};
</script>
